<button [class]="buttonClass" [title]="tooltip" (click)="showNotificationModal(notificationModal)"><span
        class="fa fa-exclamation-circle"></span></button>

<ng-template #notificationModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{notificationTitleText}}</h4>
    </div>
    <div class="modal-body">
        <p>{{notificationBodyText}}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-info" (click)="modal.close('OK')">OK</button>
    </div>
</ng-template>